// src/utils/emotion.tsx
function select(component) {
  return component.toString();
}

export {
  select
};
